import { useState } from 'react';
import { DefaultDesignBar } from '@components/DefaultDesignBar';
import { usePaginate } from '@hooks/usePaginate';
import { OrangeButton } from '@components/buttons/OrangeButton';
import { ManufacturerEditDialog } from '@components/dialogs/ManufacturerEditDialog';
import { ManufacturerTable } from '@components/tables/ManufacturerTable';
import { manufacturerFilter } from '@utils/filters';
import { useLoadDesignData } from '@hooks/useLoadDesignData';

import type { Manufacturer } from '@features/redux/slices/designSlice';

const ITEMS_PER_PAGE = 10;

export const Manufacturers = () => {
    const { manufacturers, loadManufacturers, loadingManufacturer } = useLoadDesignData();

    const [editOpen, setEditOpen] = useState(false);
    const [selectedManufacturer, setSelectedManufacturer] = useState<Manufacturer>();

    const [searchText, setSearchText] = useState('');
    const [pageNumber, setPageNumber] = useState(1);

    const [pagedItems, pageCount] = usePaginate({
        items: manufacturers,
        filter: manufacturerFilter,
        searchText,
        pageNumber,
        itemsPerPage: ITEMS_PER_PAGE,
    });

    const search = (searchText: string) => {
        setSearchText(searchText);
        setPageNumber(1);
    };

    const selectPage = (page: number) => {
        setPageNumber(page);
    };

    const openEditDialog = (manufacturer?: Manufacturer) => {
        setEditOpen(true);
        setSelectedManufacturer(manufacturer);
    };

    const closeDialog = (updatedData: boolean) => {
        setEditOpen(false);
        setSelectedManufacturer(undefined);

        if (updatedData) {
            loadManufacturers(true);
        }
    };

    return (
        <div style={{ marginTop: '180px' }}>
            <DefaultDesignBar selectedRoute={'manufacturers'} onSearch={search}>
                <OrangeButton onClick={() => openEditDialog()}>+ Manufacturer</OrangeButton>
            </DefaultDesignBar>

            <ManufacturerTable
                manufacturers={pagedItems}
                pageCount={pageCount}
                pageNumber={pageNumber}
                loadingManufacturer={loadingManufacturer}
                selectManufacturer={openEditDialog}
                selectPage={selectPage}
            />

            {editOpen && <ManufacturerEditDialog manufacturer={selectedManufacturer} cancel={closeDialog} />}
        </div>
    );
};
